import React from "react";
import YouTube from "react-youtube";

const DemoHead = (props) => {
  const { id } = props;

  const demos = [
    {
      id: 1,
      name: "Flat Jet",
      description:
        "Flat Jet is a fast-paced 2D game where you control a moving jet using a touch joystick. Change the color of your ship to match the obstacles and weapons that come your way. Collect stars and take out guns and missiles to earn points, but be careful – a single hit from the wrong color will decrease your health. Can you survive as long as possible and hit the high score?",
      videoLink: "sesOox_2asQ",
      link: "https://play.google.com/store/apps/details?id=com.GoMuneStudio.FlatJet",
      projectLink: "https://github.com/SanthushaMunasinghe/Flat-Jet",
    },
    {
      id: 2,
      name: "Play Task",
      description:
        "Developed a game-based student evaluation platform for school teachers to create subject-specific games/activities and evaluate students using game analytics. AngularJS web application with features including RxJS, Shared Services, and Angular Router. Implemented an interactive evaluation platform using Unity framework, incorporating networking, scene management, and UI design. Gained proficiency in C# OOP, including static classes, interfaces, dictionaries, MVC, factory method, singleton pattern, state pattern, scriptable objects, scene management, and data persistence (PlayerPrefs, JSON objects). Developed the backend using NodeJS, Express, and Mongoose, with a MongoDB database.",
      videoLink: "agDIcKDpoL0",
      link: "",
      projectLink: "https://github.com/SanthushaMunasinghe/Play-Task",
    },
    {
      id: 3,
      name: "Quad Zee: 2D Puzzle Game",
      description:
        "Quad Zee is an exhilarating 2D puzzle game that will test your logic, strategy, and puzzle-solving skills. As the talented developer behind this captivating experience, you'll guide players through a dynamic grid filled with colorful cubes, challenging them to select and match cubes of the same color by simply dragging their finger across the screen. The satisfying shattering effect of the cubes and the rewarding points system will keep players engaged and motivated to achieve high scores. Unlocking stars by selecting more than four cubes adds an extra layer of excitement, leading to the discovery of new stages and increasingly complex puzzles. With a minimum of 100 bricks to break to progress to the next level, players will need to carefully plan their moves to avoid a grid lock and the dreaded game-over. Quad Zee showcases your talent as a game developer, providing a visually appealing and intuitive gameplay experience that will leave players craving more addictive puzzle challenges.",
      videoLink: "vistLAOXzTg",
      link: "https://santhushamunasinghe.itch.io/quadzee",
      projectLink: "",
    },
    {
      id: 4,
      name: "Bounce (Bouncing Ball Platformer)",
      description:
        "Introducing Bounce, an addictive platformer game that puts you in control of a bouncy ball, offering a thrilling and challenging experience. With the ability to adjust the bounce height and navigate between platforms, your goal is to avoid the treacherous red obstacles and maintain momentum without falling off the edges. Along the way, collect the elusive white cubes to unlock the coveted finish line. As you gather more cubes, you earn stars, showcasing your skill and determination. Bounce combines addictive gameplay with precise controls",
      videoLink: "5ZRdOK4bc0A",
      link: "https://santhushamunasinghe.itch.io/bounce",
      projectLink: "https://github.com/SanthushaMunasinghe/Bounce",
    },
    {
      id: 5,
      name: "Dream Woods",
      description:
        "Dream Woods: A Serene Forest Simulation is a captivating and immersive PC application created using Unity Engine. With its meticulously crafted terrain, stunning lighting, and realistic particle systems, this enchanting virtual forest invites you to escape into a tranquil world of natural beauty. Accompanied by soothing music, Dream Woods seamlessly combines realism and artistic vision, providing a serene and immersive experience. Published on itch.io, this project showcases your mastery of Unity and your ability to create captivating and immersive environments, making it a standout addition to your portfolio.",
      videoLink: "vdROuubK3JE",
      link: "https://santhushamunasinghe.itch.io/dream-woods",
      projectLink: "",
    },
    {
      id: 6,
      name: "Monster Bash: A Thrilling Top-Down Shooter Game",
      description:
        "Welcome to Monster Bash, an adrenaline-pumping top-down shooter game where you take on the role of a courageous green monster. Prepare yourself for an intense battle as waves of menacing creatures emerge from the depths below. Your mission is clear: collect ammunition, unleash a barrage of bullets, and fight to achieve the highest score possible.",
      videoLink: "PldOSW3Tsh4",
      link: "https://drive.google.com/drive/folders/1W3Ail7pprwsoAkw-4Udb6TSl_LZQ_WFV",
      projectLink: "",
    },
  ];

  const demo = demos.find((demo) => demo.id === parseInt(id));

  return (
    <div
      name="demohead"
      className="w-full bg-gradient-to-b from-gray-800 to-black text-white"
    >
      <div className="max-w-screen-lg p-4 mx-auto flex flex-col w-full h-full">
        {demo ? (
          <div className="pb-8 my-4">
            <div className="my-20">
              <YouTube videoId={demo.videoLink} />
            </div>
            <p className="text-4xl font-bold inline border-b-4 border-gray-500">
              {demo.name}
            </p>
            <p className="my-4">{demo.description}</p>
            <button className="font-semibold text-gray-800 mt-10 bg-white px-6 py-2 mr-2">
              <a href={demo.link} target="blank">
                Product
              </a>
            </button>
            <button className="font-semibold text-gray-800 mt-10 bg-white px-6 py-2">
              <a href={demo.projectLink} target="blank">
                Project
              </a>
            </button>
          </div>
        ) : (
          <div className="pb-8 my-4">
            <p className="text-4xl font-bold inline border-b-4 border-gray-500">
              Demo Not Found
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default DemoHead;
